export const functionNotImplemented = (): never => {
    throw new Error('Plz implement me sensei ˶ᵔ ᵕ ᵔ˶');
};
